module.exports = __webpack_public_path__ + "1d991acb6008bb54d4f0cbb277f42052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linggongbao.png
// module id = 258
// module chunks = 1